// This file is auto-generated by the generateModuleTranslationKeys Vite plugin.
// Do not edit this file manually.
import { useTypedTranslation } from "@/shared/culture/useTypedTranslation";
import { useTranslationModule } from "./moduleTranslations";

export const IDENTITY_AND_ACCESS_TRANSLATIONS = {
  "apiTokens.actions.add": "Add API token",
  "apiTokens.actions.delete": "Delete",
  "apiTokens.actions.edit": "Edit",
  "apiTokens.databases.addDatabase": "Add database",
  "apiTokens.details.createdBy": "Created by",
  "apiTokens.details.creationDate": "Creation date",
  "apiTokens.details.guid": "GUID",
  "apiTokens.details.lastGet": "Last GET",
  "apiTokens.details.lastPost": "Last POST",
  "apiTokens.details.noGet": "No GET",
  "apiTokens.details.noPost": "No POST",
  "apiTokens.dialogs.deleteTitle":
    "Are you sure you want to delete this API token?",
  "apiTokens.dialogs.irreversible": "This action is irreversible.",
  "apiTokens.panel.createTitle": "Create API token",
  "apiTokens.panel.databases": "Databases",
  "apiTokens.panel.editTitle": "Edit API token",
  "apiTokens.panel.general": "General",
  "apiTokens.panel.permissions": "Permissions",
  "apiTokens.permissions.applyToSubcompanies":
    "Apply permissions to subcompanies",
  "apiTokens.permissions.manageAll": "Manage all",
  "apiTokens.permissions.module": "Module",
  "apiTokens.permissions.title": "Module rights",
  "apiTokens.permissions.viewAll": "View all",
  "apiTokens.secret.createdTokenToast": "Created new API-token",
  "apiTokens.secret.onceWarning": "This can only be viewed once.",
  "apiTokens.secret.title": "Your API-token",
  "apiTokens.table.company": "Company",
  "apiTokens.table.created": "Created",
  "apiTokens.table.expires": "Expires",
  "apiTokens.table.name": "Name",
  "apiTokens.title": "API tokens",
  "companies.actions.delete": "Delete",
  "companies.actions.edit": "Edit",
  "companies.actions.editTags": "Edit tags",
  "companies.dialogs.deleteTitle":
    "Are you sure you want to delete this company?",
  "companies.dialogs.irreversible": "This action is irreversible.",
  "companies.panel.allowedEmailDomains": "Allowed email domains",
  "companies.panel.autolink": "Autolink",
  "companies.panel.createTitle": "Create company",
  "companies.panel.dashboardEndpoint": "Dashboard endpoint",
  "companies.panel.databaseEndpoints": "Database endpoint(s)",
  "companies.panel.editTitle": "Edit company",
  "companies.panel.enabled": "Enabled",
  "companies.panel.enableMicrosoftAuthentication":
    "Enable Microsoft Authentication",
  "companies.panel.enableNewUnsStructure": "Enable new UNS structure",
  "companies.panel.general": "General",
  "companies.panel.installedApps": "Installed apps",
  "companies.panel.microsoftAuthenticationRequired":
    "Microsoft authentication required",
  "companies.panel.microsoftAuthenticationRequiredTooltip":
    "If enabled, users will be required to sign in with a Microsoft account.",
  "companies.panel.name": "Company name",
  "companies.panel.parentCompany": "Parent company",
  "companies.status.disabled": "Disabled",
  "companies.status.enabled": "Enabled",
  "companies.table.more": "more",
  "companies.table.name": "Company",
  "companies.table.status": "Status",
  "companies.table.tagPrefix": "Tag:",
  "companies.table.userCount": "N° of users",
  "companies.tags.addTag": "Add Tag",
  "companies.tags.tagKey": "Tag Key",
  "companies.tags.tagValue": "Tag Value",
  "companies.tags.title": "Edit tags",
  "companies.title": "Companies",
  "groups.actions.add": "Add group",
  "groups.actions.delete": "Delete",
  "groups.actions.edit": "Edit",
  "groups.dialogs.deleteTitle": "Are you sure you want to delete this group?",
  "groups.dialogs.irreversible": "This action is irreversible.",
  "groups.panel.createTitle": "Create group",
  "groups.panel.editTitle": "Edit group",
  "groups.panel.name": "Group name",
  "groups.panel.shareable": "Shareable",
  "groups.table.groupName": "Group name",
  "groups.table.notShareable": "Not shareable",
  "groups.table.shareable": "Shareable",
  "groups.title": "Groups",
  "groupsTab.members": "Group members",
  "home.apiTokens": "API tokens",
  "home.companies": "Companies",
  "home.groups": "Groups",
  "home.roles": "Roles",
  "home.title": "Identity & access",
  "home.users": "Users",
  "roles.actions.add": "Add role",
  "roles.actions.delete": "Delete",
  "roles.actions.edit": "Edit",
  "roles.dialogs.deleteTitle": "Are you sure you want to delete this role?",
  "roles.dialogs.irreversible": "This action is irreversible.",
  "roles.panel.applyPermissionsToSubcompanies":
    "Apply permissions to subcompanies",
  "roles.panel.createRole": "Create role",
  "roles.panel.createTitle": "Create role",
  "roles.panel.editTitle": "Edit role",
  "roles.panel.general": "General",
  "roles.panel.manageAll": "Manage all",
  "roles.panel.noUsersSelected": "No users selected",
  "roles.panel.permissions": "Permissions",
  "roles.panel.roleName": "Role name",
  "roles.panel.selectedUsers": "Selected users",
  "roles.panel.selectUsers": "Select users",
  "roles.panel.shareToSubcompanies": "Share role to subcompanies",
  "roles.panel.updateRole": "Update role",
  "roles.panel.users": "Users",
  "roles.panel.viewAll": "View all",
  "roles.table.name": "Role",
  "roles.table.shareable": "Shareable",
  "roles.table.users": "Users",
  "roles.title": "Roles",
  "users.actions.add": "Add user",
  "users.actions.delete": "Delete",
  "users.actions.edit": "Edit",
  "users.actions.resendInvite": "Resend invite",
  "users.actions.resetPassword": "Reset password",
  "users.dialogs.deleteTitle": "Are you sure you want to delete this user?",
  "users.dialogs.irreversible": "This action is irreversible.",
  "users.dialogs.logoutMessage":
    "You have changed your own username, if you proceed you will need to log in again.",
  "users.dialogs.logoutTitle": "You are going to log out.",
  "users.dialogs.proceed": "Proceed",
  "users.groupTab.delete": "Delete",
  "users.groupTab.selectGroup": "Select group",
  "users.groupTab.title": "Selected groups",
  "users.info.disableMfa": "Disable MFA",
  "users.info.email": "Email",
  "users.info.enableMfa": "Enable MFA",
  "users.info.forceMfa": "Force MFA",
  "users.info.microsoftAuthTooltip":
    "If enabled, the user must log in with their Microsoft account.",
  "users.info.phoneInvalid": "Invalid phone number format",
  "users.info.phoneNumber": "Phone Number",
  "users.info.role": "Role",
  "users.info.username": "Username",
  "users.info.usernameTooltip":
    "If you change your username, you'll need to log back in afterwards.",
  "users.info.usernameTooltipNew": "No special characters or spaces allowed",
  "users.mfa.codeLabel": "MFA code",
  "users.mfa.codePlaceholder": "MFA code",
  "users.mfa.disable": "Disable MFA",
  "users.mfa.enable": "Enable MFA",
  "users.mfa.enterSetupCode": "Enter setup code",
  "users.mfa.qrAlt": "QR-code",
  "users.mfa.removePrompt": "Enter code to disable.",
  "users.mfa.scanQr": "Scan QR",
  "users.mfa.step1": "1. {{mode}} in your authenticator app.",
  "users.mfa.step2": "2. Enter the generated code.",
  "users.mfa.toggleToQr": "or use QR code",
  "users.mfa.toggleToSetupCode": "or use setup code",
  "users.mfaDialog.confirm": "Disable",
  "users.mfaDialog.message":
    "Are you sure you want to disable MFA for '{{username}}'?",
  "users.mfaDialog.title": "Disable MFA",
  "users.panels.createTitle": "Create user",
  "users.panels.editTitle": "Edit user",
  "users.panels.tabs.groups": "Groups",
  "users.panels.tabs.info": "Info",
  "users.status.active": "Active",
  "users.status.disabled": "Disabled",
  "users.status.notRegistered": "Not registered",
  "users.table.company": "Company",
  "users.table.email": "Email",
  "users.table.groups": "Groups",
  "users.table.role": "Role",
  "users.table.status": "Status",
  "users.table.username": "Username",
  "users.title": "Users",
  "users.toasts.invalidPhone": "Invalid phone number",
  "users.validation.emailInvalid": "Email is not valid",
  "users.validation.phoneInvalid": "Phone number is not valid",
  "users.validation.usernameMax": "Username must be 50 characters or fewer",
  "users.validation.usernameMin": "Username must be at least 3 characters",
  "users.validation.usernameSpecialChars":
    "Can not contain any special characters ' \" ` : ´",
  "validation.invalidPhoneNumber": "invalid phone number",
} as const;

export const IDENTITY_AND_ACCESS_PLURAL_KEYS = {} as const;

export type IdentityAndAccessTranslationKey =
  keyof typeof IDENTITY_AND_ACCESS_TRANSLATIONS;
export type IdentityAndAccessPluralTranslationKey =
  keyof typeof IDENTITY_AND_ACCESS_PLURAL_KEYS;

/**
 * Typed translation hook for identity-and-access-specific keys.
 * For shared/global keys, use useCommonTranslation() instead.
 */
export function useIdentityAndAccessTranslation() {
  const isReady = useTranslationModule("identity-and-access", {
    waitForReady: true,
  });
  return useTypedTranslation<
    IdentityAndAccessTranslationKey,
    typeof IDENTITY_AND_ACCESS_TRANSLATIONS,
    IdentityAndAccessPluralTranslationKey
  >(IDENTITY_AND_ACCESS_TRANSLATIONS, IDENTITY_AND_ACCESS_PLURAL_KEYS, {
    isReady,
  });
}
